export const isRenderGroupHeader = (item: any): item is uui.domain.ui.list.RenderGroupHeader => {
  const groupHeader = item as uui.domain.ui.list.RenderGroupHeader
  return (
    typeof groupHeader.groupId === 'string' &&
    typeof groupHeader.label === 'string' &&
    typeof groupHeader.depth === 'number' &&
    (typeof groupHeader.groupId === 'number' || typeof groupHeader.groupId === 'string')
  )
}
